export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_350.ec1b2b90.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};